// Shift types — keep in sync with server/utils/shiftTypes.js.
// `label`: template dropdown; `prefLabel`: availability preference ranking.
export const SHIFT_TYPES = [
  { key: 'early_backstage', label: 'Early – Backstage', prefLabel: 'Early – Backstage' },
  { key: 'early_foh',       label: 'Early – FoH',       prefLabel: 'Early – FoH' },
  { key: 'tagesleitung',    label: 'Tagesleitung',      prefLabel: 'Tagesleitung (middleshift)' },
  { key: 'support',         label: 'Support',           prefLabel: 'Support Shift' },
  { key: 'late',            label: 'Late',              prefLabel: 'Lateshift' },
];

export const SHIFT_TYPE_KEYS = SHIFT_TYPES.map((t) => t.key);

export function shiftTypeLabel(key) {
  return SHIFT_TYPES.find((t) => t.key === key)?.label || null;
}

export function prefLabel(key) {
  return SHIFT_TYPES.find((t) => t.key === key)?.prefLabel || key;
}

// Map legacy label rankings to keys (the server converts too — safety net only).
// Keeps the user's order, drops unknown/duplicates, appends missing keys.
const LABEL_TO_KEY = Object.fromEntries(
  SHIFT_TYPES.flatMap((t) => [[t.prefLabel.toLowerCase(), t.key], [t.label.toLowerCase(), t.key], [t.key, t.key]])
);
export function normaliseRanking(ranking) {
  const out = [];
  for (const entry of Array.isArray(ranking) ? ranking : []) {
    const key = LABEL_TO_KEY[String(entry).trim().toLowerCase()];
    if (key && !out.includes(key)) out.push(key);
  }
  for (const key of SHIFT_TYPE_KEYS) if (!out.includes(key)) out.push(key);
  return out;
}

// Short names for "not qualified" badges ("no TL")
export const SHIFT_TYPE_SHORT = { early_backstage: 'BS', early_foh: 'FoH', tagesleitung: 'TL', support: 'Sup', late: 'Late' };

// Qualified types only (null/undefined `qualified` = all), in ranking order
export function visibleRanking(ranking, qualified) {
  const full = normaliseRanking(ranking);
  if (!Array.isArray(qualified)) return full;
  return full.filter((k) => qualified.includes(k));
}

// Put an edited visible ranking back into the full stored ranking: the hidden
// (unqualified) keys keep their stored positions, the qualified positions get
// the new order. The server ignores unqualified keys when scoring.
export function mergeRanking(visible, fullRanking, qualified) {
  const full = normaliseRanking(fullRanking);
  if (!Array.isArray(qualified)) return normaliseRanking(visible);
  const queue = visible.filter((k) => qualified.includes(k));
  for (const k of full) if (qualified.includes(k) && !queue.includes(k)) queue.push(k);
  return full.map((k) => (qualified.includes(k) ? queue.shift() : k));
}
